import { Box, Text, Button, Heading, Divider } from '@wix/design-system';
import classNames from 'classnames';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { DATA_HOOKS } from '../../../dataHooks';
import useWrongArticleVersion from '../../../hooks/useWrongArticleVersion';

import css from './index.module.scss';

interface WrongArticleProps {
  description: string;
  onClickFeedback: () => void;
}

export const WrongArticle = ({
  description,
  onClickFeedback,
}: WrongArticleProps) => {
  const { t } = useTranslation();
  const version = useWrongArticleVersion();

  if (!version) {
    return null;
  }

  const renderTitle = () => (
    <Heading size="medium">{t('article-page.wrong-article.title')}</Heading>
  );

  const renderDescription = () => (
    <Text size="small" weight="thin" className={css.wrongArticleDescription}>
      {description}
    </Text>
  );

  const renderButton = () => (
    <Button
      className={css.wrongArticleButton}
      onClick={() => onClickFeedback()}
      skin="standard"
      dataHook={DATA_HOOKS.WRONG_ARTICLE_YES_BUTTON}
    >
      {t('article-page.wrong-article.button')}
    </Button>
  );

  const renderContent = () => {
    if (version === 'versionB') {
      return (
        <>
          <Box direction="vertical" gap="SP1">
            {renderDescription()}
            {renderTitle()}
          </Box>
          {renderButton()}
        </>
      );
    }

    if (version === 'versionC') {
      return (
        <Box direction="vertical">
          <Box direction="vertical" gap="SP1">
            <Text size="medium" className={css.wrongArticleSubtitle}>
              {t('article-page.wrong-article.versionC.subtitle')}
            </Text>
            {renderDescription()}
          </Box>
          <Divider className={css.wrongArticleDivider} />
          <Box
            direction="horizontal"
            align="space-between"
            verticalAlign="middle"
          >
            {renderTitle()}
            {renderButton()}
          </Box>
        </Box>
      );
    }

    // versionA
    return (
      <>
        {renderTitle()}
        <Box direction="horizontal" gap="SP3">
          {renderDescription()}
          {renderButton()}
        </Box>
      </>
    );
  };
  return (
    <Box
      className={classNames(css.wrongArticleWrapper, {
        [css.wrongArticleWrapperVersionB]: version === 'versionB',
      })}
      marginTop="SP4"
      borderRadius="SP2"
      direction={version === 'versionB' ? 'horizontal' : 'vertical'}
      gap="SP1"
      padding="SP3"
    >
      {renderContent()}
    </Box>
  );
};
